const layout = {
  sideBar: {
    menu: {
      jobs: {
        title: 'Ordens',
        children: {
          jobs: 'Ordens',
        },
      },
    },
  },
};

export default layout;
